import { HubType } from '@portals/types';

export const HUB_LABEL: Record<HubType, string> = {
  [HubType.Home]: 'Home Hub',
  [HubType.Products]: 'Products Hub',
  [HubType.Ecommerce]: 'Ecommerce Hub',
  [HubType.Operations]: 'Operations Hub',
  [HubType.Finance]: 'Finance Hub',
  [HubType.Support]: 'Support Hub',
  [HubType.Marketing]: 'Marketing Hub',
};

export const HUBS_ROUTES_GROUPS = {
  [HubType.Home]: [
    'sidebar.gettingStarted',
    'sidebar.homeOverview',
    'sidebar.customers',
    'partners',
    'sidebar.settings',
  ],
  [HubType.Products]: [
    'sidebar.models',
    'sidebar.devices',
    'sidebar.files',
    'sidebar.devCenter',
  ],
  [HubType.Ecommerce]: [
    'ecommerceOverview',
    'sidebar.catalog',
    'sidebar.products',
    'orders',
    'subscriptions',
    'purchasedProducts',
  ],
  [HubType.Operations]: ['shipping'],
  [HubType.Finance]: ['sidebar.creditProviders', 'invoices', 'orders'],
  [HubType.Support]: [
    'sidebar.supportOverview',
    'sidebar.supportedCustomers',
    'sidebar.tickets',
    'sidebar.incidents',
  ],
  [HubType.Marketing]: ['sidebar.branding'],
};

export const STORE_MANAGEMENT_ROUTES = [
  'orders',
  'subscriptions',
  'purchasedProducts',
];
